import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    display: flex;
    margin: 0 8px 0 0;
    border-radius: 8px;
    background: ${props => props.bgColor};
    height: 16px;
    box-sizing: border-box;
    max-width: 100%;
  }
`

const MultiValueContainer = (props) => {
  const bgColor = props.data.bgColor || colors.secondary90

  return (
    <StyledWrapper {...props.innerProps} bgColor={bgColor}>
      {props.children}
    </StyledWrapper>
  )
}

MultiValueContainer.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  innerProps: PropTypes.object,
  children: PropTypes.node,
}

export default MultiValueContainer
